import Vue from 'vue';

function templateForm() {
    return {
        hash_id: null,
        cat_procedure_id: null
    }
}


const state = {
    templateForm: templateForm(),
};

const mutations = {

    addMangeTemplate(state, data) {
        state.templateForm = data;
    },
};

const actions = {
    addMangeTemplate({commit}, data) {
        commit('addMangeTemplate', data);
    },

};

const getters = {
    templateForm: state => state.templateForm,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

